(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Below 600px viewport height, stagger adds up to noticeable delay across
  // many sections on small phones. Disable stagger only -- reveals still fire.
  var isShortViewport = window.innerHeight < 600;

  var observer = new IntersectionObserver(
    function (entries) {
      // Collect all elements entering the viewport in this tick.
      var entering = entries.filter(function (e) { return e.isIntersecting; });
      if (!entering.length) return;

      requestAnimationFrame(function () {
        entering.forEach(function (entry, idx) {
          var el = entry.target;
          var delay = (prefersReducedMotion || isShortViewport) ? 0 : idx * 60;
          el.style.setProperty('--wasa-reveal-delay', delay + 'ms');
          el.classList.add('is-wasa-revealed');
          observer.unobserve(el);
        });
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('[data-wasa-reveal]').forEach(function (el) {
    observer.observe(el);
  });

}());
